import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
//鼠标在手机上点击延迟300毫秒缓存
import FastClick from "fastclick";
FastClick.attach(document.body);

//引入vant框架
import "./config/vant.js";
import "./assets/css/reset.css";
import "./assets/css/commonality.scss";

require('babel-polyfill');//es6
//防抖
import Debounce from "@/utils/debounce";

Vue.component("Debounce", Debounce);
Vue.directive("title", {
  inserted: function(el, binding) {
    document.title = binding.value;
  },
});
Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
